module.exports = __webpack_public_path__ + "static/media/icon-check@2x.bff829a4.svg";